import { SynchronousSiteSettingsService } from './components/shared/services/site-settings/site-settings/synchronous-site-settings.service';
import { inject } from '@angular/core';

export const resolveSiteSettingData = (): Promise<void> => {
	const siteSettingService = inject(SynchronousSiteSettingsService);

	return siteSettingService.loadSiteSettingData();
};
